module.exports = __webpack_public_path__ + "static/img/m3.94d2961.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/iot/m3.png
// module id = /MU/
// module chunks = 0